<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="剧本编码" prop="shopName">
                <a-input v-model="queryParam.scriptCode" placeholder="请输入剧本编码" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="店铺名称" prop="shopName">
                <a-input v-model="queryParam.shopName" placeholder="请输入店铺名称" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="开本类型" prop="playedType">
                <a-select v-model="queryParam.playedType" placeholder="请选择开本类型" allow-clear>
                  <a-select-option :value="1">真实开本</a-select-option>
                  <a-select-option :value="2">模拟开本</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24" v-if="queryParam.playedType !== 2">
              <a-form-item label="支付方式" prop="payChannel">
                <a-select v-model="queryParam.payChannel" placeholder="请选择支付方式" allow-clear>
                  <a-select-option :value="1">优惠券门票</a-select-option>
                  <a-select-option :value="2">元宝支付</a-select-option>
                  <a-select-option :value="3">微信支付</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24" v-if="!queryParam.payChannel || queryParam.payChannel === 1">
              <a-form-item label="优惠券类型" prop="isTestCoupon">
                <a-select v-model="queryParam.isTestCoupon" placeholder="请选择优惠券类型" allow-clear>
                  <a-select-option :value="1">测本券</a-select-option>
                  <a-select-option :value="0">预购券</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="玩本状态" prop="status">
                <a-select v-model="queryParam.status" placeholder="请选择玩本状态" allow-clear>
                  <a-select-option :value="0">未支付</a-select-option>
                  <a-select-option :value="1">已开本</a-select-option>
                  <a-select-option :value="2">已结束</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="收货省市区" prop="city">
                <a-cascader
                  :options="cityList"
                  v-model="selectedCityValue"
                  change-on-select
                  @change="onCityChange"
                  placeholder="请选择省市区"
                  :allowClear="true"
                />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="开本日期" prop="openStartDate">
                <a-date-picker style="width: 100%" @change="onCreateDateChange" format="YYYY-MM-DD" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="订单总金额" prop="orderAmount">
                <a-input-number
                  :min="0"
                  :max="999"
                  style="width: 100%"
                  v-model="queryParam.orderAmount"
                  placeholder="请输入订单总金额"
                  allow-clear
                />
              </a-form-item>
            </a-col>
<!--            <a-col :md="8" :sm="24">-->
<!--              <a-form-item label="开始时间" prop="startTime">-->
<!--                <a-date-picker style="width: 100%" v-model="queryParam.startTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
<!--            <a-col :md="8" :sm="24">-->
<!--              <a-form-item label="结束时间" prop="endTime">-->
<!--                <a-date-picker style="width: 100%" v-model="queryParam.endTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
            <a-col :md="8" :sm="24" style="float: right">
              <span class="table-page-search-submitButtons" :style="{ float: 'right', overflow: 'hidden' }">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
<!--        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['played:script/shop/open:add']">-->
<!--          <a-icon type="plus" />新增-->
<!--        </a-button>-->
<!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['played:script/shop/open:edit']">-->
<!--          <a-icon type="edit" />修改-->
<!--        </a-button>-->
<!--        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['played:script/shop/open:remove']">-->
<!--          <a-icon type="delete" />删除-->
<!--        </a-button>-->
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['played:script/shop/open:export']">-->
<!--          <a-icon type="download" />导出-->
<!--        </a-button>-->
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['played:script/shop/open:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 1800 }"
        :class="list.length === 0? 'emptyTable' : ''"
      >
        <span slot="startTime" slot-scope="text, record">
          {{ parseTime(record.startTime) }}
        </span>
        <span slot="endTime" slot-scope="text, record">
          {{ parseTime(record.endTime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="updateTime" slot-scope="text, record">
          {{ parseTime(record.updateTime) }}
        </span>
<!--        <span slot="operation" slot-scope="text, record">-->
<!--          <a-divider type="vertical" v-hasPermi="['played:script/shop/open:edit']" />-->
<!--          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['played:script/shop/open:edit']">-->
<!--            <a-icon type="edit" />修改-->
<!--          </a>-->
<!--          <a-divider type="vertical" v-hasPermi="['played:script/shop/open:remove']" />-->
<!--          <a @click="handleDelete(record)" v-hasPermi="['played:script/shop/open:remove']">-->
<!--            <a-icon type="delete" />删除-->
<!--          </a>-->
<!--        </span>-->
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageJhlOpenScript, removeJhl } from '@/api/played/scriptShopOpen'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import { convertToCascaderFormat } from '@/utils/areaDataConverter'
import { Cascader } from 'ant-design-vue'

export default {
  name: 'JhlScriptShopOpen',
  components: {
    CreateForm,
    'a-cascader': Cascader
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      playedScriptList: [],
      // cityList: [],
      selectedCityValue: [], // 用于绑定 cascader 的值
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        scriptId: undefined,
        scriptName: undefined,
        shopName: undefined,
        areap: undefined,
        areac: undefined,
        areax: undefined,
        scriptCode: undefined,
        scriptType: undefined,
        playedType: undefined,
        payChannel: undefined,
        isTestCoupon: undefined,
        orderAmount: null,
        payPrice: null,
        discountAmount: null,
        payIngot: null,
        status: undefined,
        openStartDate: null,
        startTime: null,
        endTime: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '剧本名称',
          dataIndex: 'scriptName',
          ellipsis: true,
          width: 130,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '剧本编码',
          dataIndex: 'scriptCode',
          ellipsis: true,
          width: 130,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '房间号',
          dataIndex: 'roomCode',
          ellipsis: true,
          width: 120,
          align: 'center',
          fixed: 'left'
        },
        {
          title: 'DM',
          dataIndex: 'dmName',
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '店铺名称',
          dataIndex: 'shopName',
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '省',
          dataIndex: 'areap',
          ellipsis: true,
          width: 100,
          align: 'center'
        },
        {
          title: '市',
          dataIndex: 'areac',
          ellipsis: true,
          width: 100,
          align: 'center'
        },
        {
          title: '区',
          dataIndex: 'areax',
          ellipsis: true,
          width: 100,
          align: 'center'
        },
        // {
        //   title: '剧本类型',
        //   dataIndex: 'scriptType',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '开本类型',
          dataIndex: 'playedType',
          ellipsis: true,
          align: 'center',
          width: 90,
          customRender: (text) => {
            return { 1: '真实开本', 2: '模拟开本' }[text]
          }
        },
        {
          title: '支付方式',
          dataIndex: 'payChannel',
          ellipsis: true,
          align: 'center',
          width: 90,
          customRender: (text, record) => {
            if (record.playedType === 1) {
              return { 1: '优惠券门票', 2: '元宝支付', 3: '微信支付' }[text]
            } else {
              return null
            }
          }
        },
        {
          title: '优惠券类型',
          dataIndex: 'isTestCoupon',
          ellipsis: true,
          align: 'center',
          width: 100,
          customRender: (text, record) => {
            if (record.playedType === 1 && record.payChannel === 1) {
              return { true: '测本券', false: '预购券' }[text]
            } else {
              return null
            }
          }
        },
        {
          title: '订单总金额',
          dataIndex: 'orderAmount',
          ellipsis: true,
          align: 'center',
          width: 100
        },
        {
          title: '实际订单价格',
          dataIndex: 'payPrice',
          ellipsis: true,
          align: 'center',
          width: 100
        },
        // {
        //   title: '折扣金额',
        //   dataIndex: 'discountAmount',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '使用元宝数',
          dataIndex: 'payIngot',
          ellipsis: true,
          align: 'center',
          width: 110
        },
        {
          title: '玩本状态',
          dataIndex: 'status',
          ellipsis: true,
          align: 'center',
          width: 100,
          customRender: (text) => {
            return { 0: '未支付', 1: '已开本', 2: '已结束' }[text]
          },
          fixed: 'right'
        },
        {
          title: '开始时间',
          dataIndex: 'startTime',
          scopedSlots: { customRender: 'startTime' },
          ellipsis: true,
          width: 145,
          align: 'center',
          fixed: 'right'
        },
        {
          title: '结束时间',
          dataIndex: 'endTime',
          scopedSlots: { customRender: 'endTime' },
          ellipsis: true,
          width: 145,
          align: 'center',
          fixed: 'right'
        }
        // {
        //   title: '创建时间',
        //   dataIndex: 'createTime',
        //   scopedSlots: { customRender: 'createTime' },
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '操作',
        //   dataIndex: 'operation',
        //   width: '18%',
        //   scopedSlots: { customRender: 'operation' },
        //   align: 'center'
        // }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
    cityList () {
      const rawData = this.$store.state.user.cityList
      if (rawData && rawData.length > 0) {
        return convertToCascaderFormat(rawData, 3)
      }
      return []
    }
  },
  watch: {
  },
  methods: {
    /** 查询银河打本店家开本列表 */
    getList () {
      this.loading = true
      pageJhlOpenScript(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    onCreateDateChange (date, dateString) {
      this.queryParam.openStartDate = dateString
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        scriptId: undefined,
        scriptName: undefined,
        shopName: undefined,
        areap: undefined,
        areac: undefined,
        areax: undefined,
        scriptCode: undefined,
        scriptType: undefined,
        playedType: undefined,
        payChannel: undefined,
        isTestCoupon: undefined,
        orderAmount: null,
        payPrice: null,
        discountAmount: null,
        payIngot: null,
        status: undefined,
        openStartDate: null,
        startTime: null,
        endTime: null,
        pageNum: 1,
        pageSize: 10
      }
      // 清空 cascader 选中的值
      this.selectedCityValue = []
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          return removeJhl(ids)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {}
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('played/script/shop/open/export', {
            ...that.queryParam
          }, `script/shop/open_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    },
    onCityChange(value) {
      this.queryParam.areap = undefined
      this.queryParam.areac = undefined
      this.queryParam.areax = undefined
      if (value) {
        if (value.length > 0) {
          this.queryParam.areap = value[0]
        }
        if (value.length > 1) {
          this.queryParam.areac = value[1]
        }
        if (value.length > 2) {
          this.queryParam.areax = value[2]
        }
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    }
  }
}
</script>
<style lang="less" scoped>
//.emptyTable {
//  ::v-deep .ant-table-content {
//    .ant-table-scroll {
//      .ant-table-placeholder {
//        padding: 0 !important;
//        border-top: none !important;
//      }
//    }
//  }
//}

</style>
